import { useRef as T, useEffect as l, useState as b, useCallback as M, useMemo as L } from "react";
import { renderPostBody as j } from "@ecency/render-helper";
import { clsx as B } from "clsx";
import q from "medium-zoom";
import { jsx as c, Fragment as w, jsxs as m } from "react/jsx-runtime";
import { createRoot as u, hydrateRoot as S } from "react-dom/client";
function z({
  containerRef: o
}) {
  const r = T(void 0);
  return l(() => {
    var t, e, a;
    return Array.from(((t = o.current) == null ? void 0 : t.querySelectorAll(".markdown-view:not(.markdown-view-pure) img")) ?? []).filter((i) => {
      var s;
      return ((s = i.parentNode) == null ? void 0 : s.nodeName) !== "A" && !i.classList.contains("medium-zoom-image") && !i.closest(".markdown-image-container");
    }).forEach((i) => {
      var g, k, N, _;
      const s = document.createElement("div");
      s.classList.add("markdown-image-container");
      const d = i.cloneNode(!0), p = (g = i.getAttribute("title")) == null ? void 0 : g.trim(), v = (k = i.getAttribute("data-caption")) == null ? void 0 : k.trim(), h = (N = i.getAttribute("alt")) == null ? void 0 : N.trim(), y = h ? /^[\w,\s-]+\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(h) : !1, f = p || v || (y ? "" : h);
      if (f) {
        const x = document.createElement("div");
        x.classList.add("markdown-img-caption"), x.innerText = f, s.appendChild(d), s.appendChild(x);
      } else
        s.appendChild(d);
      (_ = i.parentElement) == null || _.replaceChild(s, i);
    }), r.current = q(((e = o.current) == null ? void 0 : e.querySelectorAll(".markdown-view:not(.markdown-view-pure) img")) ?? []), (a = r.current) == null || a.update({
      background: "#131111"
    }), () => {
      var i;
      (i = r.current) == null || i.detach();
    };
  }, []), /* @__PURE__ */ c(w, {});
}
function C(o) {
  const [r, n, t, e] = o.split("/");
  return e.includes("re-ecencywaves") || e.includes("re-leothreads") || e.startsWith("wave-") || e.startsWith("re-liketu-moments");
}
const A = /* @__PURE__ */ new Map();
function F(o) {
  try {
    const r = new URL(`https://ecency.com${o}`).pathname.split("/"), n = decodeURIComponent(r[3] || ""), t = /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(n), e = /[?#]/.test(n);
    return !/^[a-z0-9-]+$/.test(n) || t || e;
  } catch {
    return !0;
  }
}
function R({
  link: o
}) {
  const [r, n] = b(), t = o.replace("https://ecency.com", "").toLowerCase(), e = M(async () => {
    var a, i, s, d;
    if (A.has(t)) {
      n(A.get(t));
      return;
    }
    if (F(t)) {
      console.warn("[Ecency Renderer] Skipping invalid post link:", t);
      return;
    }
    try {
      const v = await (await fetch(`https://ecency.com${t.toLowerCase()}`, {
        method: "GET"
      })).text(), h = document.createElement("html");
      h.innerHTML = v;
      const y = (a = h.querySelector('meta[property="og:title"]')) == null ? void 0 : a.getAttribute("content");
      if (y) {
        const f = {
          title: y,
          description: ((s = (i = h.querySelector('meta[property="og:description"]')) == null ? void 0 : i.getAttribute("content")) == null ? void 0 : s.substring(0, 71)) ?? void 0,
          // normalized
          image: ((d = h.querySelector('meta[property="og:image"]')) == null ? void 0 : d.getAttribute("content")) ?? void 0
          // normalized
        };
        A.set(t, f), n(f);
      }
    } catch (p) {
      console.error(`[Ecency Renderer] Failed to fetch preview: ${o}`, p);
    }
  }, [o]);
  return l(() => {
    e();
  }, [e]), /* @__PURE__ */ c("a", {
    href: o,
    className: "ecency-renderer-hive-post-extension-link",
    target: "_blank",
    rel: "noopener",
    children: r ? /* @__PURE__ */ m(w, {
      children: [/* @__PURE__ */ c("div", {
        className: "ecency-renderer-hive-post-extension-link-image",
        style: {
          backgroundImage: `url(${r.image})`
        }
      }), /* @__PURE__ */ m("div", {
        className: "ecency-renderer-hive-post-extension-link-text-content",
        children: [/* @__PURE__ */ c("div", {
          className: "ecency-renderer-hive-post-extension-link-type",
          children: "Hive post"
        }), /* @__PURE__ */ c("div", {
          className: "ecency-renderer-hive-post-extension-link-title",
          children: r.title
        }), /* @__PURE__ */ c("div", {
          className: "ecency-renderer-hive-post-extension-link-description",
          children: r.description + "..."
        })]
      })]
    }) : o
  });
}
function V({
  containerRef: o
}) {
  return l(() => {
    var n;
    Array.from(((n = o.current) == null ? void 0 : n.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-post-link")) ?? []).filter((t) => !C(t.getAttribute("href") ?? "")).filter((t) => {
      try {
        const [e, a, i, s] = new URL("https://ecency.com" + t.getAttribute("href")).pathname.split("/");
        return t.innerText === `${i}/${s}`;
      } catch {
        return !0;
      }
    }).forEach((t) => {
      var s;
      if (t.dataset.enhanced === "true") return;
      t.dataset.enhanced = "true";
      const e = document.createElement("div");
      e.classList.add("ecency-renderer-hive-post-extension");
      const a = t.getAttribute("href") ?? "";
      u(e).render(/* @__PURE__ */ c(R, {
        link: a
      })), (s = t.parentElement) == null || s.replaceChild(e, t);
    });
  }, []), null;
}
function $({
  author: o
}) {
  const r = `https://images.ecency.com/u${o.toLowerCase().replace("@", "")}/avatar/small`;
  return /* @__PURE__ */ m(w, {
    children: [/* @__PURE__ */ c("img", {
      src: r,
      className: "ecency-renderer-author-extension-link-image",
      alt: o
    }), /* @__PURE__ */ m("div", {
      className: "ecency-renderer-author-extension-link-content",
      children: [/* @__PURE__ */ c("span", {
        className: "ecency-renderer-author-extension-link-content-label",
        children: "Hive account"
      }), /* @__PURE__ */ c("span", {
        children: o.toLowerCase().replace("/", "")
      })]
    })]
  });
}
function O({
  containerRef: o
}) {
  return l(() => {
    var n;
    Array.from(((n = o.current) == null ? void 0 : n.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-author-link")) ?? []).forEach((t) => {
      var s;
      if (t.dataset.enhanced === "true") return;
      const e = t.getAttribute("href");
      if (!e) return;
      const a = document.createElement("a");
      a.setAttribute("href", e), a.setAttribute("target", "_blank"), a.setAttribute("rel", "noopener"), a.classList.add("ecency-renderer-author-extension"), a.classList.add("ecency-renderer-author-extension-link"), u(a).render(/* @__PURE__ */ c($, {
        author: e
      })), (s = t.parentElement) == null || s.replaceChild(a, t), a.dataset.enhanced = "true";
    });
  }, []), null;
}
function U({
  tag: o
}) {
  return /* @__PURE__ */ c("span", {
    children: o.replace("/", "")
  });
}
function Z({
  containerRef: o
}) {
  return l(() => {
    var n;
    Array.from(((n = o.current) == null ? void 0 : n.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-tag-link")) ?? []).forEach((t) => {
      var i;
      const e = document.createElement("a");
      e.setAttribute("href", t.getAttribute("href") ?? ""), e.setAttribute("target", "_blank"), e.setAttribute("rel", "noopener"), e.classList.add("ecency-renderer-tag-extension"), e.classList.add("ecency-renderer-tag-extension-link"), u(e).render(/* @__PURE__ */ c(U, {
        tag: t.innerText
      })), (i = t.parentElement) == null || i.replaceChild(e, t);
    });
  }, []), null;
}
function H({
  embedSrc: o,
  container: r
}) {
  const [n, t] = b(!1);
  return l(() => {
    const e = () => t(!0);
    return r.addEventListener("click", e), () => r.removeEventListener("click", e);
  }, []), l(() => {
    if (n) {
      const e = r.querySelector(".video-thumbnail"), a = r.querySelector(".markdown-video-play");
      e && (e.style.display = "none"), a && (a.style.display = "none");
    }
  }, [n]), n ? /* @__PURE__ */ c("iframe", {
    className: "youtube-shorts-iframe",
    src: o,
    title: "Video player",
    frameBorder: "0",
    allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: !0
  }) : null;
}
function D({
  containerRef: o
}) {
  return l(() => {
    var n;
    Array.from(((n = o.current) == null ? void 0 : n.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-video-link-youtube:not(.ecency-renderer-youtube-extension)")) ?? []).forEach((t) => {
      const e = document.createElement("div");
      e.classList.add("ecency-renderer-youtube-extension-frame"), t.classList.add("ecency-renderer-youtube-extension"), S(e, /* @__PURE__ */ c(H, {
        embedSrc: t.dataset.embedSrc ?? "",
        container: t
      })), t.appendChild(e);
    });
  }, []), /* @__PURE__ */ c(w, {});
}
const E = /* @__PURE__ */ new Map();
async function Y(o, r) {
  if (E.has(`${o}/${r}`))
    return E.get(`${o}/${r}`);
  const n = await window.dHiveClient.call(
    "condenser_api",
    "get_content",
    [o, r]
  );
  return E.set(`${o}/${r}`, n), n;
}
const G = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 148.85 148.85"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle class="ecency-logo-circle" cx="74.43" cy="74.43" r="74.43"/><path class="ecency-logo-sign" d="M88.27,105.71c-9,.08-30.35.27-35.13-.29-3.88-.46-11-3-11.11-12.81C42,87,41.66,64,42.46,59,44.13,48.4,47,41.77,59.05,36.33c10.26-4.44,32.17-.78,34.54,16.93.45,3.37,1.25,3.74,2.49,4,19.61,4.13,24,26.26,14.6,38.32C104.73,103.26,98.31,104.76,88.27,105.71ZM84.71,59.25c.68-11.52-11-19.82-22.82-13.66-8.42,4.39-9.15,10.76-9.68,18-.67,9.2-.25,15.91-.09,25.13.07,4.13,1.27,6.64,5.7,7,1.14.1,17,0,25.22.06,10.74.06,24.06-4.89,21.93-18a12.68,12.68,0,0,0-10.8-10.22,2.12,2.12,0,0,0-2.21,1C85,83,69.66,82.31,63.41,74.46c-5.61-7.06-2.7-18.73,4.68-21.2,2.78-.94,5.11-.11,6.25,1.86,1.84,3.18.11,6.06-2.49,7.65s-2.45,3.92-1.36,5.46c2.56,3.59,7.6,2.88,10.79-.28C83.87,65.4,84.52,62.47,84.71,59.25Z"/></g></g></svg>';
function W({
  link: o
}) {
  const [r, n] = b(), t = L(() => {
    var e, a, i, s;
    return (e = r == null ? void 0 : r.permlink) != null && e.startsWith("re-ecencywaves") || (a = r == null ? void 0 : r.permlink) != null && a.startsWith("wave-") ? "ecency.waves" : (i = r == null ? void 0 : r.permlink) != null && i.startsWith("re-leothreads") ? "threads" : (s = r == null ? void 0 : r.permlink) != null && s.startsWith("re-liketu-moments") ? "moments" : "";
  }, [r]);
  return l(() => {
    const [e, a, i, s, d] = new URL(`https://ecency.com/${o}`).pathname.split("/");
    Y(s.replace("@", ""), d).then((p) => {
      n(p);
    }).catch((p) => console.error(p));
  }, []), r ? /* @__PURE__ */ m("a", {
    href: `/waves/${r.author}/${r.permlink}`,
    target: "_blank",
    className: "ecency-renderer-wave-like-post-extension-renderer",
    children: [/* @__PURE__ */ m("div", {
      className: "ecency-renderer-wave-like-post-extension-renderer--author",
      children: [/* @__PURE__ */ c("img", {
        src: `https://images.ecency.com/u/${r.author}/avatar/small`,
        alt: r.author,
        className: "ecency-renderer-wave-like-post-extension-renderer--author-avatar"
      }), /* @__PURE__ */ m("div", {
        className: "ecency-renderer-wave-like-post-extension-renderer--author-content",
        children: [/* @__PURE__ */ m("a", {
          className: "ecency-renderer-wave-like-post-extension-renderer--author-content-link",
          href: `/@${r.author}/posts`,
          target: "_blank",
          children: ["@", r.author]
        }), /* @__PURE__ */ m("div", {
          className: "ecency-renderer-wave-like-post-extension-renderer--author-content-host",
          children: ["#", t]
        })]
      }), /* @__PURE__ */ c("a", {
        href: "https://ecency.com",
        target: "_blank",
        className: "ecency-renderer-wave-like-post-extension-renderer--logo",
        dangerouslySetInnerHTML: {
          __html: G
        }
      })]
    }), /* @__PURE__ */ c("div", {
      className: "ecency-renderer-wave-like-post-extension-renderer--body",
      children: /* @__PURE__ */ c(ee, {
        value: r.body
      })
    })]
  }) : /* @__PURE__ */ c(w, {});
}
function J({
  containerRef: o
}) {
  return l(() => {
    var n;
    Array.from(((n = o.current) == null ? void 0 : n.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-post-link")) ?? []).filter((t) => C(t.getAttribute("href") ?? "")).forEach((t) => {
      var a;
      const e = document.createElement("div");
      e.classList.add("ecency-renderer-wave-like-extension"), S(e, /* @__PURE__ */ c(W, {
        link: t.getAttribute("href") ?? ""
      })), (a = t.parentElement) == null || a.replaceChild(e, t);
    });
  }, []), /* @__PURE__ */ c(w, {});
}
function I({
  op: o
}) {
  const r = L(() => {
    try {
      const t = atob(o);
      return JSON.parse(t);
    } catch {
      return;
    }
  }, [o]), n = L(() => r == null ? void 0 : r[0].split("_").join(" "), [r]);
  return /* @__PURE__ */ m(w, {
    children: [/* @__PURE__ */ c("span", {
      className: "ecency-renderer-hive-operation-extension-label",
      children: "Hive operation, click to Sign"
    }), !r && o, /* @__PURE__ */ c("div", {
      className: "ecency-renderer-hive-operation-extension-content",
      children: r && /* @__PURE__ */ m(w, {
        children: [/* @__PURE__ */ c("div", {
          className: "ecency-renderer-hive-operation-extension-type",
          children: n
        }), n === "transfer" && /* @__PURE__ */ m("div", {
          className: "ecency-renderer-hive-operation-extension-transfer",
          children: [/* @__PURE__ */ c("span", {
            className: "ecency-renderer-hive-operation-extension-transfer-highlight",
            children: r[1].amount
          }), /* @__PURE__ */ c("span", {
            children: " to"
          }), /* @__PURE__ */ c("img", {
            src: `https://images.ecency.com/u/${r[1].to}/avatar/small`,
            className: "ecency-renderer-hive-operation-extension-transfer-image",
            alt: ""
          }), /* @__PURE__ */ c("span", {
            className: "ecency-renderer-hive-operation-extension-transfer-highlight",
            children: r[1].to
          })]
        })]
      })
    })]
  });
}
function K({
  containerRef: o,
  onClick: r
}) {
  return l(() => {
    var n;
    Array.from(((n = o.current) == null ? void 0 : n.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-external-link")) ?? []).filter((t) => {
      var e;
      return (e = t.innerText) == null ? void 0 : e.startsWith("hive://sign/op/");
    }).forEach((t) => {
      var s;
      const e = document.createElement("div");
      e.classList.add("ecency-renderer-hive-operation-extension");
      const a = t.innerText.replace("hive://sign/op/", "");
      e.addEventListener("click", () => r == null ? void 0 : r(a)), u(e).render(/* @__PURE__ */ c(I, {
        op: a
      })), (s = t.parentElement) == null || s.replaceChild(e, t);
    });
  }, [o, r]), null;
}
function Q({
  containerRef: o,
  ComponentInstance: r
}) {
  return l(() => {
    var t;
    Array.from(((t = o.current) == null ? void 0 : t.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-external-link")) ?? []).filter((e) => {
      const a = e.getAttribute("href") || "";
      return a.startsWith("https://x.com") || a.startsWith("https://twitter.com");
    }).forEach((e) => {
      try {
        const a = e.getAttribute("href");
        if (!a) return;
        const s = new URL(a).pathname.split("/").pop();
        if (!s) return;
        const d = document.createElement("div");
        d.classList.add("ecency-renderer-twitter-extension-frame"), e.classList.add("ecency-renderer-twitter-extension"), e.innerHTML = "", e.appendChild(d), u(d).render(/* @__PURE__ */ c(r, {
          id: s
        }));
      } catch (a) {
        console.warn("TwitterExtension failed to render tweet:", a);
      }
    });
  }, [o]), null;
}
function P({
  embedSrc: o,
  container: r
}) {
  const [n, t] = b(!1);
  return l(() => {
    const e = () => t(!0);
    return r.addEventListener("click", e), () => r.removeEventListener("click", e);
  }, []), l(() => {
    if (n) {
      const e = r.querySelector(".video-thumbnail"), a = r.querySelector(".markdown-video-play");
      e && (e.style.display = "none"), a && (a.style.display = "none");
    }
  }, [n]), n ? /* @__PURE__ */ c("iframe", {
    className: "speak-iframe",
    src: o,
    title: "3Speak video",
    frameBorder: "0",
    allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: !0
  }) : null;
}
function X({
  containerRef: o
}) {
  return l(() => {
    var n;
    Array.from(((n = o.current) == null ? void 0 : n.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-video-link-speak:not(.ecency-renderer-speak-extension)")) ?? []).forEach((t) => {
      const e = document.createElement("div");
      e.classList.add("ecency-renderer-speak-extension-frame"), t.classList.add("ecency-renderer-speak-extension"), S(e, /* @__PURE__ */ c(P, {
        embedSrc: t.dataset.embedSrc ?? "",
        container: t
      })), t.appendChild(e);
    });
  }, []), /* @__PURE__ */ c(w, {});
}
function ee({
  value: o,
  pure: r = !1,
  onHiveOperationClick: n,
  TwitterComponent: t = () => /* @__PURE__ */ c("div", {
    children: "No twitter component"
  }),
  ...e
}) {
  const a = T(null);
  return /* @__PURE__ */ m(w, {
    children: [/* @__PURE__ */ c("div", {
      ...e,
      ref: a,
      itemProp: "articleBody",
      className: B("entry-body markdown-view user-selectable", r ? "markdown-view-pure" : "", e.className),
      dangerouslySetInnerHTML: {
        __html: j(o, !1)
      }
    }), !r && /* @__PURE__ */ m(w, {
      children: [/* @__PURE__ */ c(z, {
        containerRef: a
      }), /* @__PURE__ */ c(V, {
        containerRef: a
      }), /* @__PURE__ */ c(O, {
        containerRef: a
      }), /* @__PURE__ */ c(Z, {
        containerRef: a
      }), /* @__PURE__ */ c(D, {
        containerRef: a
      }), /* @__PURE__ */ c(X, {
        containerRef: a
      }), /* @__PURE__ */ c(J, {
        containerRef: a
      }), /* @__PURE__ */ c(Q, {
        containerRef: a,
        ComponentInstance: t
      }), /* @__PURE__ */ c(K, {
        containerRef: a,
        onClick: n
      })]
    })]
  });
}
function te(o) {
  Array.from(
    o.querySelectorAll(
      ".markdown-view:not(.markdown-view-pure) img"
    )
  ).filter(
    (t) => {
      var e;
      return ((e = t.parentNode) == null ? void 0 : e.nodeName) !== "A" && !t.classList.contains("medium-zoom-image") && !t.closest(".markdown-image-container");
    }
  ).forEach((t) => {
    var h, y, f, g;
    const e = document.createElement("div");
    e.classList.add("markdown-image-container");
    const a = t.cloneNode(!0), i = (h = t.getAttribute("title")) == null ? void 0 : h.trim(), s = (y = t.getAttribute("data-caption")) == null ? void 0 : y.trim(), d = (f = t.getAttribute("alt")) == null ? void 0 : f.trim(), p = d ? /^[\w,\s-]+\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(d) : !1, v = i || s || (p ? "" : d);
    if (v) {
      const k = document.createElement("div");
      k.classList.add("markdown-img-caption"), k.innerText = v, e.appendChild(a), e.appendChild(k);
    } else
      e.appendChild(a);
    (g = t.parentElement) == null || g.replaceChild(e, t);
  }), q(
    o.querySelectorAll(
      ".markdown-view:not(.markdown-view-pure) img"
    )
  ).update({ background: "#131111" });
}
function re(o) {
  Array.from(o.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-post-link")).filter((n) => n.dataset.isInline === "false").forEach((n) => {
    var i;
    if (n.dataset.enhanced === "true") return;
    n.dataset.enhanced = "true";
    const t = n.getAttribute("href") ?? "", e = document.createElement("div");
    e.classList.add("ecency-renderer-hive-post-extension"), u(e).render(/* @__PURE__ */ c(R, {
      link: t
    })), (i = n.parentElement) == null || i.replaceChild(e, n);
  });
}
function ne(o, r) {
  Array.from(o.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-external-link")).filter((n) => n.innerText.startsWith("hive://sign/op/")).forEach((n) => {
    var i;
    if (n.dataset.enhanced === "true") return;
    n.dataset.enhanced = "true";
    const t = n.innerText.replace("hive://sign/op/", ""), e = document.createElement("div");
    e.classList.add("ecency-renderer-hive-operation-extension"), e.addEventListener("click", () => r == null ? void 0 : r(t)), u(e).render(/* @__PURE__ */ c(I, {
      op: t
    })), (i = n.parentElement) == null || i.replaceChild(e, n);
  });
}
function oe(o) {
  Array.from(o.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-author-link")).forEach((n) => {
    var i;
    if (n.dataset.enhanced === "true") return;
    n.dataset.enhanced = "true";
    const t = n.getAttribute("href");
    if (!t) return;
    const e = document.createElement("a");
    e.href = t, e.target = "_blank", e.rel = "noopener", e.classList.add("ecency-renderer-author-extension", "ecency-renderer-author-extension-link"), u(e).render(/* @__PURE__ */ c($, {
      author: t
    })), (i = n.parentElement) == null || i.replaceChild(e, n);
  });
}
function ae(o) {
  o.querySelectorAll(
    ".markdown-view:not(.markdown-view-pure) .markdown-tag-link"
  ).forEach((n) => {
    n.classList.add("ecency-renderer-tag-link-enhanced");
  });
}
function ce(o) {
  Array.from(o.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-video-link-youtube:not(.ecency-renderer-youtube-extension)")).forEach((n) => {
    if (n.dataset.enhanced === "true") return;
    n.dataset.enhanced = "true";
    const t = n.dataset.embedSrc ?? "", e = document.createElement("div");
    e.classList.add("ecency-renderer-youtube-extension-frame"), u(e).render(/* @__PURE__ */ c(H, {
      embedSrc: t,
      container: n
    })), n.appendChild(e);
  });
}
function ie(o) {
  Array.from(o.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-video-link-speak:not(.ecency-renderer-speak-extension)")).forEach((n) => {
    if (n.dataset.enhanced === "true") return;
    n.dataset.enhanced = "true";
    const t = n.dataset.embedSrc ?? "", e = document.createElement("div");
    e.classList.add("ecency-renderer-speak-extension-frame"), u(e).render(/* @__PURE__ */ c(P, {
      embedSrc: t,
      container: n
    })), n.appendChild(e);
  });
}
function se(o, r) {
  Array.from(o.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-external-link")).filter((t) => {
    const e = t.getAttribute("href") || "";
    return e.startsWith("https://x.com") || e.startsWith("https://twitter.com");
  }).forEach((t) => {
    try {
      if (t.dataset.enhanced === "true") return;
      t.dataset.enhanced = "true";
      const e = t.getAttribute("href");
      if (!e) return;
      const i = new URL(e).pathname.split("/").pop();
      if (!i) return;
      const s = document.createElement("div");
      s.classList.add("ecency-renderer-twitter-extension-frame"), t.innerHTML = "", t.appendChild(s), u(s).render(/* @__PURE__ */ c(r, {
        id: i
      }));
    } catch (e) {
      console.warn("applyTwitterEmbeds failed to render tweet:", e);
    }
  });
}
function de(o) {
  Array.from(o.querySelectorAll(".markdown-view:not(.markdown-view-pure) .markdown-post-link")).filter((n) => C(n.getAttribute("href") ?? "")).forEach((n) => {
    var i;
    if (n.dataset.enhanced === "true") return;
    n.dataset.enhanced = "true";
    const t = n.getAttribute("href") ?? "", e = document.createElement("div");
    e.classList.add("ecency-renderer-wave-like-extension"), u(e).render(/* @__PURE__ */ c(W, {
      link: t
    })), (i = n.parentElement) == null || i.replaceChild(e, n);
  });
}
function fe(o, r) {
  te(o), re(o), oe(o), ne(o, r == null ? void 0 : r.onHiveOperationClick), ae(o), ce(o), ie(o), de(o), se(o, (r == null ? void 0 : r.TwitterComponent) ?? (() => "<div>Failed to render Twitter</div>"));
}
export {
  ee as EcencyRenderer,
  fe as setupPostEnhancements
};
